<template>
  <div class="card-item" :style="{background: `no-repeat url(${bg})`, backgroundSize: '100%'}" @click="$emit('click')">
    <div class="card-title">
      <svg-icon class="bank-logo" :name="bankIcon" alt="card-logo" />
      <div>
        <div class="bank-name">{{ bankName.th }}</div>
        <div class="bank-name-en">{{ bankName.en }}</div>
      </div>
    </div>

    <div v-if="showAllCardNo" class="card-code">
      {{ allCardNo | formatBackCardNo }}
      <svg-icon
        name="eye-close"
        color="#fff"
        @click.native.stop="showAllCardNo = false"
      />
    </div>

    <div v-else class="card-code">
      {{ model.cardNo | formatBackCardNo }}
      <svg-icon
        name="eye-open"
        color="#fff"
        @click.native.stop="handleViewClick"
      />
    </div>

    <div v-if="orgIcon" class="organization">
      <svg-icon class="org-logo" :name="orgIcon" />
      <div class="org-name">{{ model.fiAccountType.description }}</div>
    </div>

    <PasswordPopup
      v-model="showPasswordPopup"
      :error.sync="passwordError"
      :code.sync="password"
      @finished="handleConfirm"
    />
  </div>
</template>

<script>
import { BANK_ICON_MAP, BANK_CARD_BG_MAP, BANK_ORG_ICON, BANK_NAME_MAP } from './config'
import { queryCard } from '@/api/card'
import formatBackCardNo from '@/utils/format-backcard-no'
import PasswordPopup from '@/components/PasswordPopup'

export default {
  name: 'CardItem',

  components: {
    PasswordPopup
  },

  filters: {
    formatBackCardNo
  },

  props: {
    model: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      BANK_NAME_MAP,
      allCardNo: null,
      showAllCardNo: false, // 是否展示全部卡片数字
      showPasswordPopup: false,
      passwordError: '',
      password: ''
    }
  },

  computed: {
    bg () {
      return BANK_CARD_BG_MAP[this.model.bankNo]
    },
    bankIcon () {
      return BANK_ICON_MAP[this.model.bankNo]
    },
    orgIcon () {
      if (!this.model.issuingBrand) return ''
      return BANK_ORG_ICON[this.model.issuingBrand]
    },
    bankName () {
      return BANK_NAME_MAP[this.model.bankNo] || {}
    }
  },

  methods: {
    async handleViewClick () {
      this.showPasswordPopup = true
    },

    handleConfirm (password) {
      queryCard({
        id: this.model.id,
        password
      })
        .then((result) => {
          this.allCardNo = result.cardNo

          this.showAllCardNo = true

          this.showPasswordPopup = false
        })
        .catch((error) => {
          this.password = ''
          this.passwordError = error.message
        })
    }
  }
}
</script>

<style scoped lang="scss">
.card-item {
  position: relative;
  margin-bottom: 40px;
  box-sizing: border-box;
  padding: 42px 36px 64px 64px;
  height: 280px;
  box-shadow: 0 8px 32px 0 rgba(138, 149, 158, 0.2);
  border-radius: 32px;
  color: #fff;

  .card-title {
    margin-bottom: 68px;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .bank-name {
      margin-bottom: 14px;
      font-size: 32px;
      text-shadow: 0 8px 32px 0 rgba(138, 149, 158, 0.2);
    }

    .bank-name-en {
      text-shadow: 0 8px 32px 0 rgba(138, 149, 158, 0.2);
      font-size: 24px;
    }
  }

  .bank-logo {
    margin-right: 16px;
    height: 64px;
    width: 64px;
  }
}

.organization {
  position: absolute;
  height: auto;
  right: 36px;
  top: 50px;

  .org-logo {
    min-height: 36px;
    min-width: 116px;
  }

  .org-name {
    margin-top: 12px;
    font-size: 20px;
    text-align: right;
  }
}
</style>
